<script lang="ts">
	import { AlertV2, ButtonV2 } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';
	import { push } from 'svelte-spa-router';
	import { format } from 'svelte-i18n';
	import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';
	import type { Device } from 'src/types/Device';

	export let heading: string;
	export let subHeading = '';
	export let isHeadingBold = false;
	export let dismissable = false;
	/** When false, only `onGetPremium` runs (e.g. Alexa sets a context flag). */
	export let navigate = true;
	export let device: Device | null = null;
	export let onGetPremium: (() => void) | null = null;

	let className = '';
	export { className as class };

	const goToPremium = () => {
		onGetPremium?.();
		if (device) {
			setSidePanelState({
				type: undefined,
				id: device.id,
				open: false,
			});
		}
		if (navigate) {
			push('/settings/premium');
		}
	};
</script>

<AlertV2
	type="premium"
	class={className}
	{heading}
	{subHeading}
	{isHeadingBold}
	{dismissable}
	on:dismissable_click
>
	<div slot="bottom" class="d-flex align-items-center">
		<ButtonV2 variant="premium" size="m" width="auto" on:click={goToPremium}>
			{capFirstChar($format('button_get_premium', { default: 'Get Premium' }))}
		</ButtonV2>
		{#if $$slots.default}
			<div class="ml-s">
				<slot />
			</div>
		{/if}
	</div>
</AlertV2>
